export const editMyself = ({ token, firstName, lastName, userId }) => ({
  HTTPMethod: "patch",
  path: `/api/v1/sso/users/${userId}`,
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {
    data: {
      profile: {
        first_name: firstName,
        last_name: lastName,
      },
    },
  },
});
